export default __webpack_public_path__ + "static/media/ALI.37701ace.svg";